import ActionCostConfig from 'modules/Recommendations/CampaignsRecommendations/Type/subcomponents/List/configs/action-cost'
import CampaignsBudget from 'modules/Recommendations/CampaignsRecommendations/Type/subcomponents/List/configs/campaign-budget'
import AccountBalance from 'modules/Recommendations/CampaignsRecommendations/Type/subcomponents/List/configs/account-balance'
import YandexMetrika from 'modules/Recommendations/CampaignsRecommendations/Type/subcomponents/List/configs/yandex-metrika'
import StrategyLearning from 'modules/Recommendations/CampaignsRecommendations/Type/subcomponents/List/configs/strategy-learning'

export default {
  'action-cost': ActionCostConfig,
  'campaign-budget': CampaignsBudget,
  'account-balance': AccountBalance,
  'yandex-metrika': YandexMetrika,
  'strategy-learning': StrategyLearning,
}
